export function customCatchError<T>(promise: Promise<T>): Promise<[undefined, T] | [Error]> {
    // @ts-ignore
    return promise.then(((data) => {
        return [undefined, data] as [undefined, T];
    })).catch((error) => {
        return [error || new Error('Error')];
    });
}

export function preventDefaultOnShiftKey(event: MouseEvent) {
    // Mainly used to prevent text-selection when shift-click is triggered
    if (event.shiftKey) {
        event.preventDefault();
    }
}
